import keycloakAxios from '@/services/axios';
import {Filter} from '@/types/filter';

export const findTrainerGroups = async (
  filter: Filter = {},
  direction: -1 | 1 | 'asc' | 'desc' = 'asc'
) => {
  const requestBody = {
    query: {
      ...filter
    },
    sort: [
      {
        key: 'start',
        direction
      }
    ]
  };

  const response = await keycloakAxios.post(
    'company/groups/trainer',
    requestBody
  );

  if (response.status >= 300) {
    throw new Error(
      `Error finding trainer groups: Invalid status code: ${response.status}`
    );
  }

  return response.data;
};
